<template>
  <div id="app">
    <Header></Header>
    <router-view @update:searchInp="getSearch" :searchInp="searchInp" />
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css"; // 引入样式
import { onBeforeRouteLeave, onBeforeRouteUpdate } from "vue-router"; // Vue Router 的钩子
export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      searchArr: "",
      searchInp: "",
    };
  },
  methods: {
    setupRouterHooks() {
      const router = this.$router; // 获取路由实例

      router.beforeEach((to, from, next) => {
        NProgress.start(); // 开始进度条
        next(); // 继续路由导航
      });

      router.afterEach(() => {
        NProgress.done(); // 结束进度条
      });
    },
    getEditSearch(val) {
      this.searchInp = val;
    },
    getSearch(val) {
      this.searchArr = val;
    },
    clearSearch(val) {
      this.searchArr = val;
    },
  },
  created() {
    this.setupRouterHooks();
  },
};
</script>
<style lang="less">
@font-face {
  font-family: "HM"; /* 自定义字体名称 */
  // src: url("@/assets/fonts/HarmonyOS_Sans_SC_Regular.ttf");
  src: url("@/assets/fonts/0e4231fd6d24c758-s.p.ttf");
}
html {
  font-family: "HM";
  // font-family: Roboto;
}
h2 {
  font-weight: normal;
}
.mainbox {
  padding: 44px 0;
  min-height: calc(100vh - 400px);
}
.form {
  .el-form-item__label {
    font-size: 19px;
    font-weight: normal;
    color: #000;
  }
  .el-input__inner {
    height: 42px;
    line-height: 42px;
    border: 1px solid #d2d2d2;
  }
  .el-checkbox__inner {
    width: 28px;
    height: 28px;
    border: 1px solid #d2d2d2;
  }
  .el-checkbox__label {
    font-size: 19px;
    color: #333;
  }

  .el-button.login-btn {
    width: 100%;
    height: 42px;
    background-color: #47e6dd;
    border: 1px solid #d2d2d2;
    span {
      color: #000;
      font-size: 19px;
    }
  }
}
</style>
